var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4688 6.02393C18.1388 5.69393 14.7887 5.52393 11.4487 5.52393C9.46875 5.52393 7.48875 5.62393 5.50875 5.82393L3.46875 6.02393",
    stroke: "#960101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96875 5.01395L9.18875 3.70395C9.34875 2.75395 9.46875 2.04395 11.1587 2.04395H13.7788C15.4688 2.04395 15.5987 2.79395 15.7487 3.71395L15.9688 5.01395",
    stroke: "#960101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3191 9.18408L18.6691 19.2541C18.5591 20.8241 18.4691 22.0441 15.6791 22.0441H9.25914C6.46914 22.0441 6.37914 20.8241 6.26914 19.2541L5.61914 9.18408",
    stroke: "#960101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7988 16.5439H14.1288",
    stroke: "#960101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96875 12.5439H14.9688",
    stroke: "#960101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.f318c346d9f875e158ca3a5e15edc8cb.svg";
export { ForwardRef as ReactComponent };